export default {
    whenFromNow: (value) => {
        if (typeof value !== 'undefined') {
            const utcDate = window.moment.utc(value)
            return window.moment(utcDate).fromNow()
        }

        return value
    },

    localDate: (value) => {
        if (value) {
            const utcDate = window.moment.utc(value)
            return utcDate.local().format('YYYY-MM-DD')
        }

        return value
    },

    localDateTime: (value) => {
        if (value) {
            const utcDate = window.moment.utc(value)
            return utcDate.local().format('YYYY-MM-DD HH:mm')
        }

        return value
    },

    dateTime: (value) => {
        if (value) {
            const utcDate = window.moment.utc(value)
            return utcDate.format('YYYY-MM-DD HH:mm')
        }

        return value
    },

    convertBoolean: (value) => {
        switch (value) {
            case 0:
            case false:
                return 'No'
            case 1:
            case true:
                return 'Yes'
            default:
                return value
        }
    },

    snakeToTitleCase: (value) =>
        value
            .replace('_', ' ')
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' '),

    nullToNA: (value) => (value === null ? 'N/A' : value),
}
